import { all } from 'redux-saga/effects';

import fetchSupports from './fetchSupports';
import { sendSupportRequestSaga } from './sendSupportRequest';

export default function* () {
    yield all([sendSupportRequestSaga(), fetchSupports()]);
}
